import React from 'react';
import { motion } from 'framer-motion';

export const MandalaCorner = ({ position = 'top-left', className = '', animate = true }) => {
  const positionStyles = {
    'top-left': 'top-0 left-0',
    'top-right': 'top-0 right-0 rotate-90',
    'bottom-left': 'bottom-0 left-0 -rotate-90',
    'bottom-right': 'bottom-0 right-0 rotate-180'
  };

  const Wrapper = animate ? motion.div : 'div';
  const animationProps = animate ? {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] }
  } : {};

  return (
    <Wrapper
      className={`absolute ${positionStyles[position]} w-24 h-24 sm:w-32 sm:h-32 pointer-events-none ${className}`}
      aria-hidden="true"
      {...animationProps}
    >
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M50 10 L55 30 L70 25 L60 40 L75 50 L60 60 L70 75 L55 70 L50 90 L45 70 L30 75 L40 60 L25 50 L40 40 L30 25 L45 30 Z"
          fill="none"
          stroke="hsl(var(--lux-gold))"
          strokeWidth="0.5"
          opacity="0.6"
        />
        <circle cx="50" cy="50" r="15" fill="none" stroke="hsl(var(--lux-gold))" strokeWidth="0.5" opacity="0.4" />
        <circle cx="50" cy="50" r="25" fill="none" stroke="hsl(var(--lux-gold))" strokeWidth="0.3" opacity="0.3" />
        <circle cx="50" cy="50" r="35" fill="none" stroke="hsl(var(--lux-gold))" strokeWidth="0.2" opacity="0.2" />
      </svg>
    </Wrapper>
  );
};
